import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HelpNode } from '../help.models';

/**
 * Renders one help node and recurses into its children.
 * A node with a `file` is a topic and renders as a router link; a node with children is a section
 * and renders as a toggle.
 */
@Component({
  selector: 'adf-help-tree-item',
  imports: [RouterLink, RouterLinkActive, HelpTreeItemComponent],
  templateUrl: './help-tree-item.component.html',
  styleUrl: './help-tree-item.component.scss',
})
export class HelpTreeItemComponent {
  @Input({ required: true }) node!: HelpNode;
  @Input() depth = 0;

  /** The sections to start open: the ancestors of the topic in the URL. */
  @Input() openIds: readonly string[] = [];

  /** `null` means "not toggled yet", so `expanded` falls back to the node's own state. */
  private _expandedOverride: boolean | null = null;

  get isTopic(): boolean {
    return !!this.node.file;
  }

  get hasChildren(): boolean {
    return (this.node.children?.length ?? 0) > 0;
  }

  get expanded(): boolean {
    // `false` is a real answer: a section the user deliberately collapsed stays collapsed.
    if (this._expandedOverride !== null) {
      return this._expandedOverride;
    }

    // An ancestor of the open topic opens whether or not it would have by default.
    return this.openIds.includes(this.node.id) || (this.node.defaultExpanded ?? false);
  }

  toggleExpanded(): void {
    this._expandedOverride = !this.expanded;
  }
}
